import { createContext, useContext } from 'react';

/**
 * @typedef {Object} FeaturesContextValue
 * @property {{ [key: string]: boolean }} features - An object where keys are feature names and values are booleans indicating whether the feature is enabled.
 */

/**
 * @type {React.Context<FeaturesContextValue | undefined>}
 */
export const FeaturesContext = createContext({
  features: {}
});

if (process.env.NODE_ENV === 'development') {
  FeaturesContext.displayName = 'FeaturesContext';
}

/**
 * A hook to access the Strava features context.
 * @returns {FeaturesContextValue} The Strava features context value.
 * @throws {Error} If the hook is used outside of a `FeaturesContext.Provider`.
 */
export function useStravaFeatures() {
  const context = useContext(FeaturesContext);

  if (!context) {
    throw new Error(
      'useStravaFeatures must be used within the FeaturesContext.Provider'
    );
  }

  return context;
}
